import { api } from "./client";
import type { Paginated, Payment, PaymentMethod } from "./types";

export interface PaymentCreatePayload {
  shop: string;
  amount: string | number;
  method?: PaymentMethod;
  reference?: string;
  notes?: string;
}

export const paymentsApi = {
  list: (params: Record<string, unknown> = {}) =>
    api.get<Paginated<Payment>>("/payments/", { params }).then((r) => r.data),
  create: (payload: PaymentCreatePayload) =>
    api.post<Payment>("/payments/", payload).then((r) => r.data),
};
